import * as React from "react";
import { MeetingObj } from "../../Entity/Objmeeting";
import Report from "./Report";
import "./Report.scss";
export interface IMeetingsProps {
  data: MeetingObj;
  UpdateMethod;
  LogTitle;
  InsideCRM;
  CRMURL;
  Phrases;
  contactlinks;
  RefreshCRMData;
}
export default class MeetingReportCalView extends React.Component<
  IMeetingsProps
> {
  constructor(props) {
    super(props);
  }
  public render() {
    let key = "CRMMeetingCalviewKey_" + this.props.data.ID;
    return (
      <div
        className="crmreport"
        draggable
        onDragStart={e => this.onDragStart(e)}
      >
        <div className={["calitem", "ellips", "draggable"].join(" ")}>
          <Report
            meeting={this.props.data}
            key={key}
            LogTitle={this.props.LogTitle}
            UpdateMethod={this.props.UpdateMethod}
            InsideCRM={this.props.InsideCRM}
            CRMURL={this.props.CRMURL}
            Phrases={this.props.Phrases}
            contactlinks={this.props.contactlinks}
            RefreshCRMData={this.props.RefreshCRMData}
          />
        </div>
      </div>
    );
  }
  public onDragStart = ev => {
    let dragdata = {
      id: this.props.data.ID,
      type: "crmmeeting",
      colno: this.props.data.MeetingColmn,
      property: "MeetRepFollow",
      source: ev.target.parentElement.id
    };
    ev.dataTransfer.setData("text/plain", JSON.stringify(dragdata));
    /*
        ev.dataTransfer.setData("id", this.props.data.ID.toString());
        ev.dataTransfer.setData("type", 'crmmeeting');
        ev.dataTransfer.setData("colno", this.props.data.MeetingColmn.toString());
        ev.dataTransfer.setData("property", 'MeetRepFollow');
        ev.dataTransfer.setData("source", ev.target.parentElement.id);
        */
    /*ev.dataTransfer.setData("text/plain",this.props.data.ID);
        ev.dataTransfer.setData("text/plain", 'crmmeeting');*/
  };
}
